import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { DateTime, padTime } from '../../../utils/datetime'
import { _ } from '../../../utils/localization'
import useFloorMapLink from '../../../hooks/useFloorMapLink'
import useCountDown from '../../../hooks/useCountDown'

const S = {
    Countdown: styled.div`
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        user-select: none;
    `,

    CountdownHeader: styled.h1`
        font-weight: bold;
    `,

    CountdownRow: styled.div`
        display: flex;
    `,

    TimeUnit: styled.h5`
        width: 160px;
        text-align: center;
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
        @media (max-width: 1152px) {
            width: 120px;
        }
    `,
    Time: styled.h5`
        width: 160px;
        text-align: center;
        font-weight: bold;
        font-size: 80px;
        @media (max-width: 1152px) {
            width: 120px;
            font-size: 60px;
        }
    `,

    TimeSeperator: styled.h5`
        width: 12px;
        font-size: 60px;
        line-height: 96px;
        @media (max-width: 1152px) {
            font-size: 40px;
            line-height: 72px;
        }
    `,

    Link: styled(Link)`
        margin-top: 24px;
        color: white;
    `,
}

const Countdown = ({ datetime }: { datetime: DateTime }) => {
    const floorMapLink = useFloorMapLink()
    const {
        daysLeft: daysToGo,
        hoursLeft: hoursToGo,
        minutesLeft: minutesToGo,
        secondsLeft: secondsToGo
    } = useCountDown(datetime)
    return (
        <S.Countdown>
            <S.CountdownHeader>{_('presentation.countdown.starting_in')}</S.CountdownHeader>
            <S.CountdownRow>
                <S.Time>{padTime(daysToGo)}</S.Time>
                <S.TimeSeperator>:</S.TimeSeperator>
                <S.Time>{padTime(hoursToGo)}</S.Time>
                <S.TimeSeperator>:</S.TimeSeperator>
                <S.Time>{padTime(minutesToGo)}</S.Time>
                <S.TimeSeperator>:</S.TimeSeperator>
                <S.Time>{padTime(secondsToGo)}</S.Time>
            </S.CountdownRow>
            <S.CountdownRow>
                <S.TimeUnit>{_('presentation.countdown.days')}</S.TimeUnit>
                <S.TimeSeperator />
                <S.TimeUnit>{_('presentation.countdown.hours')}</S.TimeUnit>
                <S.TimeSeperator />
                <S.TimeUnit>{_('presentation.countdown.minutes')}</S.TimeUnit>
                <S.TimeSeperator />
                <S.TimeUnit>{_('presentation.countdown.seconds')}</S.TimeUnit>
            </S.CountdownRow>
            <S.Link to={floorMapLink}>
                {_('presentation.countdown.back_to_map')}
            </S.Link>
        </S.Countdown>
    )
}

export default Countdown
